import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=047d2720&scoped=true"
import script from "./integration.vue?vue&type=script&lang=js"
export * from "./integration.vue?vue&type=script&lang=js"
import style0 from "./integration.vue?vue&type=style&index=0&id=047d2720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d2720",
  null
  
)

export default component.exports